import { AppDispatch } from '@/Redux/ConfigureStore';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { shippingLabelModalAsyncActions } from '@/ModalWindows/ShippingLabelModal/services';
import { LogisticType, LogisticTypeKeys } from '@/Enums';
import { GetOrderLogisticContractResponse } from '@/Api/LogisticContracts/Responses/GetOrderLogisticContractResponse';
import { globalHistory } from '@/GlobalHistory';
import { PagesRouting } from '@/Routing';
import { logisticSettingsActions } from '@/Pages/Settings/modules/LogisticsSettings/services/reducer';
import { Nullable, OrderAutomatizaionRow } from '@/Types';

export const useShipCheaperLogisticContract = (rowData: OrderAutomatizaionRow) => {
  const dispatch: AppDispatch = useDispatch();

  const [showWarningModal, setShowWarningModal] = useState(false);
  const [contractInfo, setContractInfo] = useState<Nullable<GetOrderLogisticContractResponse>>();

  useEffect(() => {
    dispatch(
      shippingLabelModalAsyncActions.getOrderLogisticContract({
        type: LogisticTypeKeys.ShipCheaper,
        orderId: rowData.orderId,
      }),
    ).then((response) => {
      setContractInfo(response.payload as GetOrderLogisticContractResponse);
    });
  }, []);

  const onRedirect = () => {
    setShowWarningModal(false);

    if (!contractInfo?.contract) return;

    globalHistory.push(PagesRouting.SettingsPages.LogisticSettings);
    const { contract, warehouseLocationId } = contractInfo;

    dispatch(
      logisticSettingsActions.setContractModal({
        visible: true,
        contractId: contract.id,
        logisticType: LogisticType.ShipCheaper,
        locationId: warehouseLocationId,
        mandatId: contract.mandatId,
      }),
    );
  };

  return {
    contractInfo,
    showWarningModal,
    setShowWarningModal,
    onRedirect,
  };
};
